import React, {useMemo} from 'react';
import {SalesforceAccount, SalesforceAccountField} from 'api';
import Text from './Text';
import Date from './Date';
import Checkbox from './Checkbox';
import Number from './Number';
import Url from './Url';

interface Props {
  field: SalesforceAccountField;
  salesforceAccount: SalesforceAccount;
}

export const FieldValue: React.FC<Props> = ({field, salesforceAccount}) => {
  const Value = useMemo(() => {
    const value = salesforceAccount.addition[`${field.fieldName}`];

    if (field.fieldType === 'checkbox') {
      return <Checkbox field={field} salesforceAccount={salesforceAccount} />;
    } else if (field.fieldType === 'address') {
      const hash = value;
      if (!hash) {
        return null;
      }
      const address = `${hash?.state}${hash?.city}${hash?.street}`;
      return <div>{address}</div>;
    } else if (
      ['text', 'phone'].includes(field.fieldType) &&
      field.updateable
    ) {
      return <Text field={field} salesforceAccount={salesforceAccount} />;
    } else if (field.fieldType === 'date' && field.fieldName.endsWith('__c')) {
      return <Date field={field} salesforceAccount={salesforceAccount} />;
    } else if (
      ['currency', 'int'].includes(field.fieldType) &&
      field.updateable
    ) {
      return <Number field={field} salesforceAccount={salesforceAccount} />;
    } else if (field.fieldType === 'url' && field.updateable) {
      return <Url field={field} salesforceAccount={salesforceAccount} />;
    } else {
      return <div>{value}</div>;
    }
  }, [field, salesforceAccount.addition]);

  return (
    <div className="flex px-4 align-middle text-foreground">
      <div className="w-2/5 text-sm ">{field.label}</div>
      <div className="w-3/5">{Value}</div>
    </div>
  );
};
